import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";

export class EmailVerificationResendRequest implements IRequestModel {

    uri: string = "auth/email-verification";
    method: HttpMethod = HttpMethod.PATCH;

    isValid(): ValidationResponse {
        return ValidationResponse.Success();
    }
}